import { SquareStyled } from './square.styled';

interface SquareProps {
  children?: React.ReactNode;
}

export const Square: React.FC<SquareProps> = ({ children }) => (
  <SquareStyled>{children}</SquareStyled>
);
